import styled from 'styled-components';
import { MULTIPLE_LINES_TITLE, TWO_LINES_TITLE } from '../../../css-constants';

export const GameTitleDefaultBox = styled.div<{ hasTwoLinesTitle?: boolean }>`
    position: relative;
    text-align: center;
    color: ${props => props.theme.colors.backgroundContrast};
    opacity: 1;
    font-size: 1.4rem;
    line-height: 1.3;
    width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    direction: initial;
    padding-bottom: 2px;

    &.${TWO_LINES_TITLE} {
        max-width: 90%;
        white-space: initial;
    }
    @media ${({ theme }) => theme.mediaQuery.lAndBelow} {
        font-size: 1.2rem;
        padding-bottom: 0;

        &.${MULTIPLE_LINES_TITLE} {
            &::after {
                content: "...";
                position: absolute;
                top: 16px;
            }
        }
    }

    @media ${({ theme }) => theme.mediaQuery.sAndBelow} {
        font-size: 1.2rem;
    }
`;
